import { useTranslation } from 'react-i18next';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import modalStyles from '../UI/Modal.module.css';
import styles from './DeleteTemplateModal.module.css';

interface DeleteTemplateModalProps {
  templateName: string;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeleteTemplateModal = ({ templateName, onConfirm, onClose }: DeleteTemplateModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('config-delete-template-title')}
      onClose={onClose}
      width={568}
      footer={
        <div className={modalStyles.footerRow}>
          <Button type="secondary" onClick={onClose}>
            {t('config-delete-template-cancel')}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {t('config-delete-template-confirm')}
          </Button>
        </div>
      }
    >
      <div className={styles.body}>
        <p className={styles.message}>
          {t('config-delete-template-message', { name: templateName || t('config-unnamed-template') })}
        </p>
        <p className={styles.warning}>
          {t('config-delete-template-warning')}
        </p>
      </div>
    </Modal>
  );
};
